import { Component } from "react";
import { Modal } from "office-ui-fabric-react";
import { PrimaryButton } from "office-ui-fabric-react/lib-commonjs";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { toggleProjectsCrudModal } from "../../actions/project-crud-actions";
import "./index.css";
import ProjectsCrud from "../ProjectsCrud";

class ProjectsCrudModal extends Component{
    closeModal = () => {
        this.props.toggleProjectsCrudModal(false);
    };

    render() {
        const {
            lang,
            content,
        } = this.props;

        return (
            <Modal
                isBlocking={false}
                titleAriaId="titleId"
                subtitleAriaId="subtitleId"
                onDismiss={() => this.closeModal()}
                isOpen={this.props.showProjectsCrudModal}
                containerClassName="ms-modalExample-container projects-crud-modal"
            >
                <div id="subtitleId" className="ms-modalExample-body">
                    <div className="ms-Grid" dir="rtl">
                        <div className={"ms-Grid-row projects-modal-header"}>
                            <div className="ms-Grid-col">
                                <PrimaryButton onClick={this.closeModal} text={content[lang].close}/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <ProjectsCrud/>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = state => {
    return {
        lang: state.localization.lang,
        content: state.localization.content,
        showProjectsCrudModal: state.projectsCrud.showProjectsCrudModal,
    };
};

const mapDispatchToProps = {
    toggleProjectsCrudModal,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProjectsCrudModal);



// WEBPACK FOOTER //
// ./src/components/ProjectsCrudModal/index.js